import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, ElementRef, KeyValueDiffers, Input, Output, Directive, NgModule } from '@angular/core';
import 'daterangepicker';
import $ from 'jquery';

let DaterangepickerConfig = class DaterangepickerConfig {
    constructor() {
        this.settings = {};
    }
};
DaterangepickerConfig.ɵprov = ɵɵdefineInjectable({ factory: function DaterangepickerConfig_Factory() { return new DaterangepickerConfig(); }, token: DaterangepickerConfig, providedIn: "root" });
DaterangepickerConfig = __decorate([
    Injectable({
        providedIn: 'root'
    })
], DaterangepickerConfig);

let DaterangepickerComponent = class DaterangepickerComponent {
    constructor(input, config, differs) {
        this.input = input;
        this.config = config;
        this.differs = differs;
        this.targetOptions = {};
        this._differ = {};
        this.options = {};
        this.selected = new EventEmitter();
        this.cancelDaterangepicker = new EventEmitter();
        this.applyDaterangepicker = new EventEmitter();
        this.hideCalendarDaterangepicker = new EventEmitter();
        this.showCalendarDaterangepicker = new EventEmitter();
        this.hideDaterangepicker = new EventEmitter();
        this.showDaterangepicker = new EventEmitter();
        this._differ['options'] = this.differs.find(this.options).create();
        this._differ['settings'] = this.differs.find(this.config.settings).create();
    }
    ngAfterViewInit() {
        this.render();
        this.attachEvents();
    }
    ngDoCheck() {
        let optionsChanged = this._differ['options'].diff(this.options);
        let settingsChanged = this._differ['settings'].diff(this.config.settings);
        if (optionsChanged || settingsChanged) {
            this.render();
            this.attachEvents();
            if (this.activeRange && this.datePicker) {
                this.datePicker.setStartDate(this.activeRange.start);
                this.datePicker.setEndDate(this.activeRange.end);
            }
        }
    }
    ngOnDestroy() {
        this.destroyPicker();
    }
    render() {
        this.targetOptions = Object.assign({}, this.config.settings, this.options);
        $(this.input.nativeElement).daterangepicker(this.targetOptions, this.callback.bind(this));
        if (this.options.customClasses && this.options.customClasses.length) {
            for (let customClass of this.options.customClasses) {
                this.datePicker = $(this.input.nativeElement).data('daterangepicker').container.addClass(customClass);
            }
        }
        else {
            this.datePicker = $(this.input.nativeElement).data('daterangepicker');
        }
    }
    callback(start, end, label) {
        this.activeRange = {
            start: start,
            end: end,
            label: label
        };
        this.selected.emit(this.activeRange);
    }
    destroyPicker() {
        try {
            $(this.input.nativeElement).data('daterangepicker').remove();
        }
        catch (e) {
            console.log(e.message);
        }
    }
    attachEvents() {
        $(this.input.nativeElement).on('cancel.daterangepicker', (e, picker) => {
            let event = { event: e, picker: picker };
            this.cancelDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('apply.daterangepicker', (e, picker) => {
            let event = { event: e, picker: picker };
            this.applyDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('hideCalendar.daterangepicker', (e, picker) => {
            let event = { event: e, picker: picker };
            this.hideCalendarDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('showCalendar.daterangepicker', (e, picker) => {
            let event = { event: e, picker: picker };
            this.showCalendarDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('hide.daterangepicker', (e, picker) => {
            let event = { event: e, picker: picker };
            this.hideDaterangepicker.emit(event);
        });
        $(this.input.nativeElement).on('show.daterangepicker', (e, picker) => {
            let event = { event: e, picker: picker };
            this.showDaterangepicker.emit(event);
        });
    }
};
DaterangepickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: DaterangepickerConfig },
    { type: KeyValueDiffers }
];
__decorate([
    Input()
], DaterangepickerComponent.prototype, "options", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "selected", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "cancelDaterangepicker", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "applyDaterangepicker", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "hideCalendarDaterangepicker", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "showCalendarDaterangepicker", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "hideDaterangepicker", void 0);
__decorate([
    Output()
], DaterangepickerComponent.prototype, "showDaterangepicker", void 0);
DaterangepickerComponent = __decorate([
    Directive({
        selector: '[daterangepicker]'
    })
], DaterangepickerComponent);

let Daterangepicker = class Daterangepicker {
};
Daterangepicker = __decorate([
    NgModule({
        declarations: [DaterangepickerComponent],
        imports: [],
        exports: [DaterangepickerComponent]
    })
], Daterangepicker);

/*
 * Public API Surface of ng2-daterangepicker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Daterangepicker, DaterangepickerComponent, DaterangepickerConfig };
